import { CabinetManagerRoleType } from 'shared/entities/manager';
import { urls } from 'shared/entities/domain';

type RoleAllowedMasks = Partial<Record<CabinetManagerRoleType, string[]>>;

export const ROLE_ALLOWED_MASKS: RoleAllowedMasks = {
  [CabinetManagerRoleType.operator]: [
    urls.PROJECT.tabs.CONVERSATIONS.mask,
    urls.PROJECT.tabs.SCENARIO.mask
  ]
};
